const UPDATE_INIT_PROGRESS = 'scratch-gui/init-progress/UPDATE_INIT_PROGRESS';
const RESET_INIT_PROGRESS = 'scratch-gui/init-progress/RESET_INIT_PROGRESS';

const initialState = {
    percent: 0
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_INIT_PROGRESS:
        return Object.assign({}, state, {
            percent: action.percent
        });
    case RESET_INIT_PROGRESS:
        return initialState;
    default:
        return state;
    }
};

const updateInitProgress = function (percent) {
    return {
        type: UPDATE_INIT_PROGRESS,
        percent: percent
    };
};

const resetInitProgress = function () {
    return {
        type: RESET_INIT_PROGRESS
    };
};

export {
    reducer as default,
    initialState as initProgressInitialState,
    updateInitProgress,
    resetInitProgress
};
